const Types = {
  CLEAR: '@protocolo-busca/CLEAR',
  SEARCH_TOTAIS_REQUEST: '@protocolo-busca/SEARCH_TOTAIS_REQUEST',
  SEARCH_TOTAIS_SUCCESS: '@protocolo-busca/SEARCH_TOTAIS_SUCCESS',
  SEARCH_REQUEST: '@protocolo-busca/SEARCH_REQUEST',
  SEARCH_SUCCESS: '@protocolo-busca/SEARCH_SUCCESS',
  SEARCH_FAILURE: '@protocolo-busca/SEARCH_FAILURE',
  LOAD_FILTER_REQUEST: '@protocolo-busca/LOAD_FILTER_REQUEST',
  LOAD_FILTER_FAILURE: '@protocolo-busca/LOAD_FILTER_FAILURE',
  LOAD_FILTER_SUCESS: '@protocolo-busca/LOAD_FILTER_SUCCESS',
  SEARCH_FILTERS_REQUEST: '@protocolo-busca/SEARCH_FILTERS_REQUEST',
  SEARCH_FILTERS_SUCCESS: '@protocolo-busca/SEARCH_FILTERS_SUCCESS',
  SEARCH_FILTERS_FAILURE: '@protocolo-busca/SEARCH_FILTERS_FAILURE',
};

export default Types;
